
// Caméscope en particules : les points arrivent de partout au scroll
// et s'assemblent complètement un peu avant la fin du site
const camWrap = document.getElementById('camwrap');
const camTilt = document.getElementById('camtilt');
const camCanvas = document.getElementById('camimg');
const camCtx = camCanvas.getContext('2d');
const startSection = document.getElementById('pack');
// particules : départ dispersé, trajectoire courbe, délai et caractère propres à chacune
const rnd = (i, k) => { const h = Math.sin(i * k) * 43758.5453; return h - Math.floor(h); };
const CAM_Y = 280; // le caméscope vit dans le bas du canvas, les flammes au-dessus
const CAM_PARTS = CAM_DOTS.map(([x, y0, r], i) => ({
  x, y: y0 + CAM_Y, r,
  sx: x + Math.cos(rnd(i, 127.1) * 6.2832) * (420 + rnd(i, 311.7) * 900),
  sy: y0 + CAM_Y + Math.sin(rnd(i, 127.1) * 6.2832) * (420 + rnd(i, 311.7) * 900),
  d: rnd(i, 74.3) * 0.55,             // délai d'arrivée
  curve: (rnd(i, 45.9) - 0.5) * 160,  // courbure de la trajectoire
  ph: rnd(i, 12.7) * 6.2832,          // phase de respiration
  lag: 0.02 + rnd(i, 91.3) * 0.06,    // inertie au scroll
  ember: rnd(i, 63.1) < 0.16,         // braise à l'embrasement
  ox: 0, oy: 0                        // décalage souris amorti
}));
// léger dépassement à l'arrivée (les points "claquent" en place)
const easeBack = t => { const c = 1.4; return 1 + (c + 1) * Math.pow(t - 1, 3) + c * Math.pow(t - 1, 2); };
let scrollVel = 0, lastSY = scrollY, mouseX = -9999, mouseY = -9999, smx = -9999, smy = -9999;
window.addEventListener('mousemove', e => { mouseX = e.clientX; mouseY = e.clientY; });
// flammes en particules : chaque point du design devient une braise vivante
const FLAME_PARTS = FLAME_DOTS.map(([x, y, r, c], i) => ({
  x, y, r, c,
  d: rnd(i, 57.7),
  ph: rnd(i, 19.3) * 6.2832,
  ph2: rnd(i, 83.1) * 6.2832,
  h: (513 - y) / 488,        // hauteur relative : plus c'est haut, plus ça danse
  ox: 0, oy: 0
}));
function drawCam(p, time, burning) {
  const assemble = Math.min(p / 0.8, 1);   // tout est en place à 80% du scroll
  const f = Math.min(Math.max((p - 0.8) / 0.12, 0), 1); // intensité des flammes
  scrollVel += ((scrollY - lastSY) - scrollVel) * 0.12;
  lastSY = scrollY;
  const vel = Math.max(-40, Math.min(40, scrollVel));
  // souris dans le repère du canvas, adoucie (pas de saut si le curseur passe vite)
  const rect = camCanvas.getBoundingClientRect();
  const rawX = (mouseX - rect.left) / rect.width * 780;
  const rawY = (mouseY - rect.top) / rect.height * 860;
  if (smx < -5000) { smx = rawX; smy = rawY; }
  smx += (rawX - smx) * 0.08;
  smy += (rawY - smy) * 0.08;
  const mcx = smx, mcy = smy;
  camCtx.clearRect(0, 0, 780, 860);
  // ---- les flammes brûlent d'elles-mêmes ----
  if (f > 0) {
    for (const fp of FLAME_PARTS) {
      const t = Math.min(Math.max((f - fp.d * 0.4) / 0.6, 0), 1);
      if (t <= 0) continue;
      // mouvement de feu : lent et contenu, la silhouette du visuel reste lisible
      let x = fp.x + Math.sin(time * 0.9 + fp.ph) * (1 + 3 * fp.h)
                   + Math.sin(time * 0.4 + fp.ph2) * 1.5 * fp.h;
      let y = fp.y + Math.cos(time * 1.1 + fp.ph2) * 1
                   - (Math.sin(time * 0.7 + fp.ph) * 0.5 + 0.5) * 4 * fp.h;
      // répulsion souris, même douceur que le caméscope
      const dx = x - mcx, dy = y - mcy, d2 = dx * dx + dy * dy;
      let txp = 0, typ = 0;
      if (d2 < 10000 && d2 > 0.01) {
        const d = Math.sqrt(d2), push = (100 - d) / 100 * 34 * t;
        txp = dx / d * push; typ = dy / d * push;
      }
      fp.ox += (txp - fp.ox) * 0.05;
      fp.oy += (typ - fp.oy) * 0.05;
      x += fp.ox; y += fp.oy;
      // scintillement de braise, doux
      camCtx.fillStyle = fp.c;
      camCtx.globalAlpha = t * (0.72 + 0.28 * Math.sin(time * 1.8 + fp.ph2));
      camCtx.beginPath();
      camCtx.arc(x, y, fp.r * (0.88 + 0.12 * Math.sin(time * 1.4 + fp.ph)) * (0.5 + 0.5 * t), 0, 6.2832);
      camCtx.fill();
    }
    camCtx.globalAlpha = 1;
  }
  for (const pt of CAM_PARTS) {
    const raw = Math.min(Math.max((assemble - pt.d) / 0.45, 0), 1);
    if (raw <= 0) continue;
    const t = easeBack(raw);
    let x = pt.sx + (pt.x - pt.sx) * t;
    let y = pt.sy + (pt.y - pt.sy) * t;
    // trajectoire courbe pendant le vol
    const arc = Math.sin(raw * Math.PI) * pt.curve;
    x += arc * 0.35; y -= Math.abs(arc) * 0.2;
    // respiration permanente : jamais figé (ondulation qui traverse la nuée)
    const wave = Math.sin(time * 1.1 + (pt.x + pt.y) * 0.006);
    x += (Math.sin(time * 1.2 + pt.ph) * 1.6 + wave * 1.4) * raw;
    y += (Math.cos(time * 0.9 + pt.ph * 1.7) * 1.6 + wave * 1.1) * raw;
    // inertie au scroll : la nuée traîne légèrement derrière
    y -= vel * pt.lag * 6 * raw;
    // répulsion douce : chaque point glisse lentement vers son écart, puis revient
    const dx = x - mcx, dy = y - mcy, d2 = dx * dx + dy * dy;
    let txp = 0, typ = 0;
    if (d2 < 10000 && d2 > 0.01) {
      const d = Math.sqrt(d2), push = (100 - d) / 100 * 34 * raw;
      txp = dx / d * push; typ = dy / d * push;
    }
    pt.ox += (txp - pt.ox) * 0.05;
    pt.oy += (typ - pt.oy) * 0.05;
    x += pt.ox; y += pt.oy;
    // braises rouges quand ça brûle
    if (burning && pt.ember) {
      const fl = 0.6 + 0.4 * Math.sin(time * 9 + pt.ph * 3);
      camCtx.fillStyle = `rgba(230,57,70,${fl.toFixed(2)})`;
    } else {
      camCtx.fillStyle = '#f2f2f2';
    }
    camCtx.globalAlpha = 0.25 + 0.75 * raw;
    camCtx.beginPath();
    camCtx.arc(x, y, pt.r * (0.5 + 0.5 * raw), 0, 6.2832);
    camCtx.fill();
  }
  camCtx.globalAlpha = 1;
}
if (camWrap) {
  let mx = 0, my = 0, tx = 0, ty = 0;
  window.addEventListener('mousemove', e => {
    mx = e.clientX / innerWidth - 0.5;
    my = e.clientY / innerHeight - 0.5;
  });
  function camLoop() {
    const time = performance.now() / 1000;
    tx += (mx - tx) * 0.04;
    ty += (my - ty) * 0.04;
    const start = startSection.offsetTop - innerHeight * 0.55;
    const max = document.documentElement.scrollHeight - innerHeight;
    const p = Math.min(Math.max((scrollY - start) / (max - start), 0), 1);
    const burning = p > 0.9;
    drawCam(p, time, burning);
    // mouvement d'ensemble : flottement 3D ample mais lent, type objet en apesanteur
    const solid = Math.min(Math.max((p - 0.55) / 0.3, 0), 1); // monte en présence après l'assemblage
    // un seul mouvement : lévitation très lente (période ~25s) + inclinaison souris
    const bob  = Math.sin(time * 0.25) * 7 * solid;
    const rotY = tx * 18;
    const rotX = -ty * 8;
    const tz   = Math.sin(p * Math.PI) * 120; // approche puis recul au scroll
    camTilt.style.transform =
      `translate3d(0px, ${bob.toFixed(2)}px, ${tz.toFixed(1)}px) ` +
      `rotateX(${rotX.toFixed(2)}deg) rotateY(${rotY.toFixed(2)}deg)`;
    camWrap.classList.toggle('visible', scrollY > start);
    camWrap.classList.toggle('burning', burning);
    requestAnimationFrame(camLoop);
  }
  camLoop();
}

// Modales (guide des tailles, expédition, CGV, contact)
const backdrop = document.getElementById('modal-backdrop');
const modalContent = document.getElementById('modal-content');
document.querySelectorAll('[data-modal]').forEach(el => {
  el.addEventListener('click', e => {
    e.preventDefault();
    const tpl = document.getElementById(el.dataset.modal);
    if (!tpl) return;
    modalContent.innerHTML = tpl.innerHTML;
    const box = backdrop.querySelector('.modal-box');
    box.classList.toggle('chart', el.dataset.modal === 'tpl-tailles');
    backdrop.classList.add('open');
  });
});
backdrop.addEventListener('click', e => {
  if (backdrop.dataset.lock) return;
  if (e.target === backdrop || e.target.classList.contains('modal-close')) backdrop.classList.remove('open');
});
document.addEventListener('keydown', e => { if (e.key === 'Escape' && !backdrop.dataset.lock) backdrop.classList.remove('open'); });

// Menu burger
const burger = document.getElementById('burger');
const mainNav = document.querySelector('header nav');
if (burger) {
  burger.addEventListener('click', () => {
    const open = mainNav.classList.toggle('open');
    burger.textContent = open ? '✕' : '☰';
  });
  mainNav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
    mainNav.classList.remove('open');
    burger.textContent = '☰';
  }));
}



// Easter egg : zone cliquable sur le caméscope dans la scène finale
function openSecret() {
  const tpl = document.getElementById('tpl-secret');
  if (!tpl) return;
  modalContent.innerHTML = tpl.innerHTML;
  backdrop.querySelector('.modal-box').classList.add('wide');
  backdrop.classList.add('open');
  const v = modalContent.querySelector('video');
  if (v) v.play().catch(() => {});
}
const eggZone = document.getElementById('egg-zone');
if (eggZone) eggZone.addEventListener('click', openSecret);

// Apparition au scroll
const io = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
}, { threshold: 0.12 });
document.querySelectorAll('.reveal').forEach(el => io.observe(el));

// Vidéo merch : clic sur la miniature -> lecture
const player = document.getElementById('merch-player');
const bgVideos = document.querySelectorAll('video[autoplay]');
if (player) {
  const vid = player.querySelector('video');
  const overlay = player.querySelector('.video-overlay');
  overlay.addEventListener('click', () => {
    overlay.classList.add('hidden');
    player.classList.add('playing');
    vid.controls = true;
    vid.play();
  });
  vid.addEventListener('play', () => bgVideos.forEach(v => v.pause()));
  vid.addEventListener('pause', () => bgVideos.forEach(v => v.play()));
}





/* ===== La fermeture d'une fenêtre coupe le son de sa vidéo ===== */
(function () {
  var bd = document.getElementById('modal-backdrop');
  var mc = document.getElementById('modal-content');
  var box = bd ? bd.querySelector('.modal-box') : null;
  if (!bd || !mc || !box) return;
  new MutationObserver(function () {
    if (!bd.classList.contains('open')) {
      mc.querySelectorAll('video, audio').forEach(function (v) {
        try { v.pause(); v.currentTime = 0; } catch (e) {}
      });
      mc.innerHTML = '';                 // libère complètement le lecteur
      box.classList.remove('wide');
      box.classList.remove('chart');
    }
  }).observe(bd, { attributes: true, attributeFilter: ['class'] });
})();


/* ===================== LECTEUR AUDIO — GESTIONNAIRE UNIQUE ===================== */
(function () {
  var audio  = document.getElementById('theme-audio');
  var ctl    = document.getElementById('music-ctl');
  var btn    = document.getElementById('mute-btn');
  var slider = document.getElementById('vol');
  var icOn   = document.getElementById('ic-on');
  var icOff  = document.getElementById('ic-off');
  var fold   = document.getElementById('music-collapse');
  if (!audio || !ctl || !btn || !slider) return;

  var veut   = true;    // le visiteur veut la musique
  var enPause = false;  // mise en veille : un autre son joue
  var spotifyActif = false;

  audio.loop = true;
  audio.volume = (parseInt(slider.value, 10) || 12) / 100;
  audio.addEventListener('error', function () { ctl.classList.add('off'); });

  function estFond(el) {                       // vidéos décoratives = pas de son
    return el === audio || el.muted || el.hasAttribute('autoplay');
  }
  function autreSonEnCours() {
    if (spotifyActif) return true;
    var vids = document.querySelectorAll('video, audio');
    for (var i = 0; i < vids.length; i++) {
      if (vids[i] !== audio && !vids[i].paused && !estFond(vids[i])) return true;
    }
    return false;
  }
  function appliquer() {
    if (veut && !enPause && !document.hidden) {
      audio.play().catch(function () {});
    } else {
      audio.pause();
    }
    var coupe = !veut || audio.paused || audio.muted;
    icOn.style.display  = coupe ? 'none' : 'block';
    icOff.style.display = coupe ? 'block' : 'none';
    ctl.classList.toggle('playing', !coupe);
    btn.setAttribute('aria-label', coupe ? 'Lancer le thème' : 'Couper le thème');
  }

  // --- commandes du visiteur ---
  btn.addEventListener('click', function () { veut = !veut; audio.muted = false; appliquer(); });
  slider.addEventListener('input', function () { audio.volume = slider.value / 100; });
  if (fold) fold.addEventListener('click', function () {
    var mini = ctl.classList.toggle('mini');
    fold.textContent = mini ? '\u266a' : '\u25c2';
  });

  // --- un autre son démarre : on s'efface ---
  document.addEventListener('play', function (e) {
    var el = e.target;
    if ((el.tagName !== 'VIDEO' && el.tagName !== 'AUDIO') || estFond(el)) return;
    enPause = true; appliquer();
  }, true);

  // --- il s'arrête : on revient, mais seulement si plus rien ne joue ---
  function peutReprendre() {
    setTimeout(function () {
      if (!autreSonEnCours()) { enPause = false; appliquer(); }
    }, 250);
  }
  document.addEventListener('pause', function (e) {
    var el = e.target;
    if (el === audio || (el.tagName !== 'VIDEO' && el.tagName !== 'AUDIO') || estFond(el)) return;
    peutReprendre();
  }, true);
  document.addEventListener('ended', function (e) {
    if (e.target !== audio) peutReprendre();
  }, true);

  // --- Spotify (iframe) : on ne peut pas l'écouter, on suit le focus ---
  var spot = document.querySelector('.spotify-player');
  if (spot) {
    window.addEventListener('blur', function () {
      if (document.activeElement === spot) { spotifyActif = true; enPause = true; appliquer(); }
    });
    document.addEventListener('click', function (e) {
      if (spotifyActif && !e.target.closest('.spotify-player')) { spotifyActif = false; peutReprendre(); }
    });
  }

  // --- onglet en arrière-plan : silence, puis reprise ---
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) audio.pause(); else appliquer();
  });

  // --- démarrage immédiat : la piste tourne en sourdine (autorisé partout),
  //     le son s'active au premier geste, sans redémarrer le morceau ---
  var vol_cible = audio.volume;
  var evts = ['pointermove','mousemove','pointerdown','click','keydown','wheel','touchstart','scroll'];

  function demarrerMuet() {
    if (!veut || enPause) return;
    audio.muted = true;
    audio.play().catch(function () {});
  }
  function activerSon() {
    if (!veut || enPause || document.hidden) return;
    audio.muted = false;
    if (audio.volume === 0) audio.volume = vol_cible;
    if (audio.paused) audio.play().catch(function () {});
    if (!audio.paused && !audio.muted) { retirer(); appliquer(); }
  }
  function retirer() {
    evts.forEach(function (ev) { window.removeEventListener(ev, activerSon, true); });
  }
  evts.forEach(function (ev) { window.addEventListener(ev, activerSon, { capture: true, passive: true }); });

  demarrerMuet();                                   // la musique tourne dès l'ouverture
  activerSon();                                     // si le navigateur l'autorise déjà, le son sort tout de suite
  document.addEventListener('DOMContentLoaded', function () { demarrerMuet(); activerSon(); });
  window.addEventListener('load', function () { demarrerMuet(); activerSon(); });
  appliquer();
})();

/* ===== Toute la carte est cliquable : on suit le lien du bouton ===== */
(function () {
  document.querySelectorAll('.card, .pack').forEach(function (carte) {
    var lien = carte.querySelector('a.buy');
    if (!lien || !lien.href) return;
    carte.style.cursor = 'pointer';
    carte.addEventListener('click', function (e) {
      if (e.target.closest('a, button, input, select, video, iframe')) return; // vrais liens et boutons gardent leur rôle
      window.location.href = lien.href;
    });
  });
})();
